import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import { TReportingPaymentsReqParams, TReportingPaymentsResData } from '../types/reporting.types';

export const reportingPaymentsService = async (
  counterpartyGUID: string,
  params: TReportingPaymentsReqParams = {},
): Promise<TReportingPaymentsResData> => {
  const config = {
    params,
  };
  const url = API_ENDPOINTS.PAYMENTS.COUNTERPARTY_PAYMENTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<TReportingPaymentsResData>(url, config);

  return res.data;
};

export const reportingPaymentsAdminService = async (
  params: TReportingPaymentsReqParams = {},
): Promise<TReportingPaymentsResData> => {
  const config = {
    params,
  };
  const url = API_ENDPOINTS.PAYMENTS.ADMIN_PAYMENTS;
  const res = await apiClient.get<TReportingPaymentsResData>(url, config);

  return res.data;
};
